module.exports = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  SHOW_EXPIRED_NOTIFICATION: 'SHOW_EXPIRED_NOTIFICATION',
};
